import { memo } from 'react';

import { PropertiesSelectors, UserSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';

import accessUtils from '../../../utils/accessUtils';

import ArchivedBanner from '../../../components/postingPath/ArchivedBanner';
import RestrictionsBanner from '../../../containers/PropertyDetailsContainer/components/RestrictionsBanner';
import ListingRouteBackBanner from '../../../components/postingPath/ListingRouteBackBanner';
import PartialListingBanner from '../../../components/postingPath/PartialListingBanner';
import FeedListingSourceBanner from '../../../components/postingPath/FeedListingSourceBanner';
import CustomerListingProblemsBanner from '../../../components/postingPath/CustomerListingProblemsBanner';
import ListingStatusBanner from '../../../components/postingPath/ListingStatusBanner';

const Banners = (): JSX.Element => {
  const { syndication } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));
  const user = useSelector((state) => UserSelectors.makeUser(state));

  const canFeedConnectSwitchSource = accessUtils.canFeedConnectSwitchSource({ user });

  return (
    <>
      <ArchivedBanner />
      <RestrictionsBanner />
      <ListingRouteBackBanner />
      <PartialListingBanner />
      {canFeedConnectSwitchSource && <FeedListingSourceBanner />}
      <CustomerListingProblemsBanner customerProblems={syndication?.customerProblems} />
      <ListingStatusBanner universal={syndication.universal} syndicationStatus={syndication.status} />
    </>
  );
};

export default memo(Banners);
